import { getObjectInitialCompletionSuccess } from '../../../../../../redux/reducers/insertion/insertionFeature'
import { getInsertionGeoCoordinatesCompletionSuccess } from '../../../../../../redux/reducers/address/addressFeature'
import { queryGeoCodes } from '../../../../../../redux/thunks/gisService/gisService'
import { getAttachmentsInitialCompletionSuccess } from '../../../../../../redux/reducers/multimedia/multimediaFeature'
import { configureObjectChooser } from '../../../../../../redux/actions/flowInformation/flowInformation'
import { DisplayObjectChooserType } from '../../../../../../@types/object-chooser-types'
import { useCallback } from 'react'
import { useAppDispatch } from '../../../../../../app/hooks'
import { ConvertedRealEstate } from '../../../../../../@types/real-estate-api-types'
import { validateCurrentInsertion } from '../../../../../../redux/thunks/insertionData/insertionData'
import { hasUsableGeoCoordinates } from '../../../../../../utils/geo-utils'

export function useOpenWizardWithCurrentDataCallback(
  object: ConvertedRealEstate,
  createNewRealEstateInOma: boolean = false
) {
  const openWizardWithCurrentData = useOpenWizardWithCurrentData()

  return useCallback(() => {
    openWizardWithCurrentData(object, createNewRealEstateInOma)
  }, [createNewRealEstateInOma, object, openWizardWithCurrentData])
}

export function useOpenWizardWithCurrentData() {
  const dispatch = useAppDispatch()

  return useCallback(
    (object: ConvertedRealEstate, createNewRealEstateInOma: boolean = false) => {
      const { listing, meta, geoCoordinates } = object

      dispatch(
        getObjectInitialCompletionSuccess({
          insertionData: { ...listing, published: false },
          insertionIdentification: {
            ...meta,
            realEstateId: createNewRealEstateInOma ? undefined : meta.realEstateId,
          },
        })
      )
      if (hasUsableGeoCoordinates(geoCoordinates)) {
        dispatch(getInsertionGeoCoordinatesCompletionSuccess({ geoCoordinates: geoCoordinates! }))
      } else {
        dispatch(queryGeoCodes())
      }
      object.attachments && dispatch(getAttachmentsInitialCompletionSuccess({ initAttachments: object.attachments }))

      dispatch(configureObjectChooser(DisplayObjectChooserType.NO, undefined, true, true))

      dispatch(validateCurrentInsertion())
    },
    [dispatch]
  )
}
